/**
 * 인증 관련 API 클라이언트 설정
 * - Axios 인스턴스 생성
 * - 요청/응답 인터셉터 설정
 * - 개발 환경에서의 로깅 처리
 */
import { generateHeaders, getCommonHeaders } from '@/api/headers';
import logger from '@/utils/logger';
import { isDevelopment } from '@/utils/util';
import axios from 'axios';

/**
 * API 클라이언트 인스턴스 생성
 * - 기본 URL 설정
 * - 타임아웃 설정
 * - 기본 헤더 설정
 */
export const apiClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  timeout: 10000,
  headers: getCommonHeaders(),
});

/**
 * 요청 인터셉터
 * - 개발 환경에서 요청 정보 로깅
 */
apiClient.interceptors.request.use((config) => {
  Object.assign(config.headers, generateHeaders());

  if (isDevelopment()) {
    const url = config.url ?? decodeURIComponent(config.url ?? '');
    logger.info(`🔑 Request: ${config.method?.toUpperCase()} ${url}`);
    if (config.data) {
      logger.info(config.data);
    }
  }
  return config;
});

/**
 * 응답 인터셉터
 * - 개발 환경에서 응답 정보 로깅
 * - 에러 처리 및 로깅
 */
apiClient.interceptors.response.use(
  (response) => {
    if (isDevelopment()) {
      logger.info('✅ Response: ', response.status, response.config.url);
      logger.info(response.data);
    }
    return response;
  },
  async (error) => {
    return Promise.reject(error);
  },
);

export default apiClient;
